import PropTypes from 'prop-types';
import React from 'react';
import {Tabs, Tab} from '@mui/material';
import styles from './TabSection.module.css';
import {useSelector} from 'react-redux';
import {hasRbacTabOrSectionPermission} from '../../../../utils/appUtils';

const TabSection = ({loanType = null, tabValue, handleChange, tabs, rbac}) => {
  const {roleBased} = useSelector(state => state.rbacValue);
  const {applicationType} = useSelector(state => state.loanListPayload);

  return (
    <Tabs
      value={tabValue}
      onChange={(_event, newValue) => handleChange(newValue)}
      textColor="secondary"
      indicatorColor="secondary"
      aria-label="secondary tabs example"
      classes={{root: styles.tabs}}
      TabIndicatorProps={{
        className: styles.tabsIndicator,
      }}
      transitionDuration={0}
      variant="scrollable"
      scrollButtons="auto">
      {tabs.map((tab, index) =>
        hasRbacTabOrSectionPermission(
          roleBased,
          loanType ?? rbac?.stage,
          tab.rbackey,
          null,
        ) ||
        applicationType === 'Rejected Applications' ||
        applicationType === 'On Hold' ||
        applicationType === 'Loan Search' ||
        applicationType === 'Conversation' ? (
          <Tab
            key={index}
            value={tab.tabName}
            label={tab.tabName}
            className={`${styles.tab} ${
              tabValue === tab.tabName ? styles.selectedTab : styles.defaultTab
            }`}
            disableRipple
            disableFocusRipple
            sx={'text-medium-16px'}
          />
        ) : loanType === 'Display' ? (
          <Tab
            key={index}
            value={tab.tabName}
            label={tab.tabName}
            className={`${styles.tab} ${
              tabValue === tab.tabName ? styles.selectedTab : styles.defaultTab
            }`}
            disableRipple
            disableFocusRipple
            sx={'text-medium-16px'}
          />
        ) : null,
      )}
    </Tabs>
  );
};

TabSection.propTypes = {
  rbac: PropTypes.object,
  handleChange: PropTypes.func,
  tabValue: PropTypes.any,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string.isRequired,
    }),
  ).isRequired,
  loanType: PropTypes.string,
};

export default TabSection;
